// @ts-check
/** @typedef {import('../types').HeaderProps} HeaderProps */

import { Link } from 'gatsby'
import React, { useState } from 'react'
import { FaPhone, FaBars, FaTimes } from 'react-icons/fa'
import Logo from '../images/prosource_logo.inline.svg'

/**
 * @typedef {Object} NavLink
 * @property {string} label
 * @property {string} path
 */

/**
 * @param {HeaderProps & { title?: string }} props
 * @returns {React.JSX.Element}
 */
const Header = ({ location }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  /** @type {NavLink[]} */
  const navLinks = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about/' },
     { label: 'Services', path: '/services/' },
     { label: 'Contact', path: '/contact/' },
  ]

  return (
    <header>
      {/* Top bar with phone number */}
      <div className="headerTopBar">
        <div className="container-custom flexBetween">
          <div className="headerTopLeft">
            <a href="tel:5035551234" className="phoneLink">
              <FaPhone size={14} />
              (503) 555-1234
            </a>
            <span className="textGray600">Serving Olympia & the I-5 Corridor</span>
          </div>
          <div className="headerTopRight">
            <span className="textGray600">Licensed & Insured</span>
            <span className="badge badgeGreen">
              Available 7 Days
            </span>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="headerMain">
        <Link to="/" className="headerLogo">
          <div className="logoIcon">
            <Logo alt="ProSource Logo" className="logoImage" />
          </div>
          <div className="logoTextWrapper">
            <div className="logoName">ProSource</div>
            <div className="logoSubtitle">Home Inspection</div>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <ul className="desktopNav">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`navLink ${
                  location?.pathname === link.path ? 'active' : ''
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/contact/" className="btnPrimary">
              Schedule Inspection
            </Link>
          </li>
        </ul>

        {/* Mobile menu button */}
        <button
          className="mobileMenuBtn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </nav>

      {/* Mobile Navigation */}
      <div className={`mobileNav ${isMenuOpen ? 'open' : ''}`}>
        <ul className="flexCol gap0-5">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`mobileNavItem ${
                  location?.pathname === link.path ? 'active' : ''
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li className="mt0-5">
            <Link to="/contact/" className="btnPrimary" onClick={() => setIsMenuOpen(false)}>
              Schedule Inspection
            </Link>
          </li>
        </ul>
      </div>
    </header>
  )
}

export default Header
